/*
 * @Description: '错误'页面所有路由
 * @Author: mike ma *
 * @Date: 2021-02-24 16:50:00
 * @LastEditTime: 2021-02-27 20:12:42
*/

export default [
    {
        path: '/error-500',
        component: resolve => require(['@/views/error/500'], resolve),
        name: 'Error-500'
    },
    {
        path: '*',
        component: resolve => require(['@/views/error/404'], resolve),
        name: 'Error-404'
    }
      
]


// WEBPACK FOOTER //
// ./src/router/error.js